module.exports = __webpack_public_path__ + "assets/img/natrium-2.18d82e9062a01255e06270cb420914bd.png";